import { useHandlers } from '../../../context/page-context';
import type { SectionsApiContract } from '../api/sections.api';

export function useSectionsApi(companyId: string): { sectionsApi: SectionsApiContract } {
  const { apis } = useHandlers();
  const sectionsApi = apis.companies
    .company({ by: 'sparklayer', identifier: companyId })
    .sections();
  return { sectionsApi };
}
